<template>
  <!-- <div class="login-container ub main-center cross-center"> -->
  <div class="login-container">
    <!--
	作者：1105095026@qq.com
	时间：2020-07-27
	描述：size用于控制表单内组件的尺寸(medium/small/mini)
		rules:用于表单验证
		ref:类似于div给定的id，表单被引用时的名称，表单验证时this.$refs.loginForm.validate中用到
		model:绑定数据
		label-width:给后面<el-form-item>的label加margin-left
		el-row:相当于css3的弹性盒子模型布局，一行分为24等份
    -->
    <div class="top">
      <div class="top-left">
        <img class="login-logo" :src='logoSrc'/>
        <span class="login-title">锦辉物联发电管理平台</span>
      </div>
      <!-- <div class="top-right"></div> -->
    </div>
    <div class="bg"></div>
    <el-form
      size="mini"
      @submit.native.prevent="submit"
      :rules="rules"
      ref="loginForm"
      :model="loginForm"
      label-width="80px"
      class="loginForm"
    >
      <el-form-item prop="username" label>
        <el-input
          type="text"
          v-model="loginForm.username"
          @keyup.enter.native="submit()"
          class="login-input"
          placeholder="请输入用户名"
        ></el-input>
        <i class="input-icon iconfont icon-user"></i>
      </el-form-item>
      <el-form-item prop="password" label>
        <el-input
          type="password"
          v-model="loginForm.password"
          @keyup.enter.native="submit()"
          class="login-input"
          placeholder="请输入密码"
        ></el-input>
        <i class="input-icon iconfont icon-password"></i>
      </el-form-item>
      <el-form-item prop="captcha" label>
        <el-row :gutter="20">
          <el-col :span="13">
            <el-input
              v-model="loginForm.captcha"
              @keyup.enter.native="submit()"
              placeholder="请输入验证码"
            ></el-input>
            <i class="input-icon iconfont icon-verification-code"></i>
          </el-col>
          <el-col :span="10" :offset="1">
            <img
              @click="getImage"
              :src="imgSrc"
              class="codeImg"
              alt="网络请求失败"
            />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button @click="submit()" class="my-button" type="primary"
              >登录</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <p
      style="position: fixed;bottom: 20px;width: 100%;height: 30px;line-height: 30px;text-align: center;margin-bottom: 0px;color: #999aaa;font-size: 12px;"
    >
      Copyright ©2021 {{companyName}}
    </p>
    <div
      style="position: fixed;bottom: 0px;width:100%;margin:0 auto;text-align:center"
    >
      <a
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
      >
        <p
          style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-size:12px;"
        >
          浙ICP备2021017244号
        </p>
      </a>
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802011651"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
      >
        <img src="../assets/images/copy.png" style="float:left;" />
        <p
          style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-size:12px;"
        >
          浙公网安备 33010802011651号
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgSrc: "",
      companyType:'',
      logoSrc:"",
      companyName:"杭州锦辉科技有限公司",
      loginForm: {
        username: "",
        password: "",
        captcha: "",
      },
      rules: {
        username: [
          {
            required: true,
            trigger: "blur",
            message: "请输入用户名",
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "请输入密码",
          },
        ],
        captcha: [
          {
            required: true,
            trigger: "blur",
            message: "请输入验证码",
          },
        ],
      },
    }
  },
  created() {
    this.getImage()
    this.getLogoSrc()
  },
  methods: {
    async getLogoSrc() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/type")
      if (res.code == 1) {
        let data = res.data.companyType
        switch(data){
          case 4:
            _this.logoSrc=require("../assets/images/logoIcon4.png");
            _this.companyName="中国移动通信集团有限公司"
            break;
          case 5:
            _this.logoSrc=require("../assets/images/logoIcon5.png");
            _this.companyName="中国联合网络通信集团有限公司"
            break;
          case 6:
            _this.logoSrc=require("../assets/images/logoIcon6.png");
            _this.companyName="中国电信集团有限公司"
            break;
          default:
            _this.logoSrc=require("../assets/images/logo.png");
            _this.companyName="杭州锦辉科技有限公司"
            break;
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    getImage() {
      this.imgSrc = "api/sys/captcha?t=" + new Date().getTime()
    },
    async submit() {
      let _this = this
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          let { data: res } = await _this.$axios.post(
            "/api/sys/login",
            _this.loginForm
          )
          if (res.code == 1) {
            let menuList = res.data.menu
            let routerList = res.data.routing
            let rolesList = res.data.roles
            let sessionId = res.data.sessionId
            let companyType = res.data.companyType
            let companyName = res.data.companyName
            let noticeSwitch = res.data.noticeSwitch
            // 存储公告控制按钮
            sessionStorage.setItem("noticeSwitch", noticeSwitch)
            //存储websocket识别码
            sessionStorage.setItem("sessionId", sessionId)
            // 存储登录账户所属运维部门类型
            sessionStorage.setItem("companyType", companyType)
            // 存储运行监控顶部部门名称
            sessionStorage.setItem("companyName", companyName)
            //存储菜单数据
            sessionStorage.setItem("menuList", JSON.stringify(menuList))
            //存储路由数据
            sessionStorage.setItem("routerList", JSON.stringify(routerList))
            //按钮权限数据存储
            sessionStorage.setItem("rolesList", JSON.stringify(rolesList))
            this.$message({
              showClose: true,
              message: "登录成功！",
              type: "success",
            })
          } else {
            _this.$message.warning(res.msg)
          }
          //存储用户名
          sessionStorage.setItem("user", _this.loginForm.username)
          //提交到store
          this.$store.commit("getMenuList", this.$router)
          //登录成功跳转到首页
          let hasTag = false
          //获取用户的按钮权限
          let permissions = JSON.parse(sessionStorage.getItem("rolesList"))
          for (let i = 0; i < permissions.length; i++) {
            if (permissions[i] === "maintain:monitor:general:v3") {
              hasTag = true
              break
            }
          }
          if (hasTag) {
            this.$router.push("monitor")
          } else {
            this.$router.push("desktop")
          }
        }
      })
    },
    clear() {
      this.$refs.loginForm.resetFields()
      Object.assign(this.loginForm, this.$options.data().loginForm)
    },
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  position: relative;
  height: 100%;
  min-height: 600px;
  min-width: 900px;
  //background-size: 100% 100%;
}
.top {
  width: 100%;
  height: 12%;
  position: relative;
}
.top-left {
  // width: 466px;
  height: 48px;
  position: absolute;
  left: 5%;
  top: 30%;
}
.login-logo {
  float: left;
  height: 48px;
  margin-right: 24px;
}
.login-title {
  float: left;
  height: 48px;
  line-height: 48px;
  font-size: 32px;
}
.top-right {
  width: 400px;
  height: 60px;
  position: absolute;
  top: 26%;
  right: 19.3%;
  background: url("../assets/images/login-text.png") no-repeat;
  background-size: 100% 100%;
}
.bg {
  width: 100%;
  height: 480px;
  background: url("../assets/images/login-bg.png") no-repeat;
  background-size: 100% 100%;
}
.loginForm {
  width: 480px;
  height: 360px;
  position: absolute;
  top: 18%;
  right: 16%;
  border-radius: 20px;
  box-shadow: 0 0 25px #000;
  padding: 48px 50px;
  background: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}
.login-container /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.login-container /deep/ .el-input__inner {
  width: 100%;
  height: 42px;
  padding-left: 66px;
  font-size: 16px;
}
.my-button {
  width: 100%;
  height: 42px;
  font-size: 16px;
}
.codeImg {
  width: 100%;
  cursor: pointer;
  color: #fff;
  line-height: 42px;
}
.el-form-item__error:before {
  content: " ";
  display: block;
  position: absolute;
  width: 13px;
  height: 13px;
  background-size: contain;
  top: 0px;
  left: -17px;
  background-image: url("../assets/images/avatar.jpg");
}
.input-icon {
  width: 50px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  position: absolute;
  top: 9px;
  left: 0;
  border-right: 1px solid #999;
  color: #0094ff;
  font-size: 22px;
}
</style>
